/**
 * Acordeón FAQ — apertura/cierre suave (.sec-faq__item).
 */
export function marianistaInitFaqAccordion() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const DURATION = 400;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  document.querySelectorAll('.sec-faq__item').forEach((details) => {
    if (!(details instanceof HTMLDetailsElement)) {
      return;
    }

    const summary = details.querySelector('.sec-faq__question');
    const panel = details.querySelector('.sec-faq__panel');
    const inner = panel?.querySelector('.sec-faq__answer');

    if (!summary || !panel || !inner) {
      return;
    }

    if (details.dataset.faqAnim === '1') {
      return;
    }
    details.dataset.faqAnim = '1';

    panel.style.overflow = 'hidden';
    panel.style.transition = `max-height ${DURATION}ms ${EASING}`;

    let animating = false;

    const panelHeight = () => inner.scrollHeight;

    const setHeight = (px) => {
      panel.style.maxHeight = typeof px === 'number' ? `${px}px` : px;
    };

    const syncClosed = () => {
      setHeight(0);
    };

    const syncOpen = () => {
      setHeight(panelHeight());
    };

    if (details.open) {
      details.open = true;
      syncOpen();
    } else {
      syncClosed();
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (animating) {
        return;
      }

      if (details.open) {
        animating = true;
        setHeight(panelHeight());
        panel.getBoundingClientRect();
        setHeight(0);

        const onEnd = (e) => {
          if (e.target !== panel || e.propertyName !== 'max-height') {
            return;
          }
          panel.removeEventListener('transitionend', onEnd);
          details.open = false;
          syncClosed();
          animating = false;
        };

        panel.addEventListener('transitionend', onEnd);
        return;
      }

      animating = true;
      details.open = true;
      syncClosed();

      requestAnimationFrame(() => {
        panel.getBoundingClientRect();
        setHeight(panelHeight());

        const onEnd = (e) => {
          if (e.target !== panel || e.propertyName !== 'max-height') {
            return;
          }
          panel.removeEventListener('transitionend', onEnd);
          setHeight('none');
          animating = false;
        };

        panel.addEventListener('transitionend', onEnd);
      });
    });

    window.addEventListener('resize', () => {
      if (details.open && !animating) {
        setHeight(panelHeight());
      }
    });
  });
}
